import { render, staticRenderFns } from "./CategoryEdit.vue?vue&type=template&id=a676d108&scoped=true&lang=pug"
import script from "./CategoryEdit.vue?vue&type=script&lang=ts"
export * from "./CategoryEdit.vue?vue&type=script&lang=ts"
import style0 from "./CategoryEdit.vue?vue&type=style&index=0&id=a676d108&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a676d108",
  null
  
)

export default component.exports